export interface IServiceTypeList {
  name: string;
  serviceFee: string;
  type: number;
  openStatus?: boolean;
}

export enum ONLINE_STATUS {
  UNKONWN,
  ONLINE,
  OFFLINE
}

export enum DOCTOR_JOBTYPE {
  APPLY = 0, // 普通用户
  FULLTIME = 1, // 全职医生
  PARTTIME = 2, // 兼职医生
  ASSISTANT = 3, // 开方医生，药师
  VERIFIED = 4 // 加V医生
}

export interface IDoctorInfo {
  affiliationHospital: string; // 医生所属医院
  answerRate: number; // 医生回答率
  answerTotal: number; // 医生回答量
  avatar: string; // 医生头像
  doctorId: number; // 医生快手ID
  doctorName: string; // 医生名称
  goodProject: string; // 医生擅长
  nickname: string; // 医生昵称
  praiseRate: number; // 医生好评率
  rankName: string; // 医生职级名称
  rankType: number; // 医生职级类型
  resume: string; // 医生简介
  merchantId: number; // 医生虚拟ID
  onlineTime: string; // 医生在线时间
  status: ONLINE_STATUS; // 医生在线状态
  correspondingTime: number;
  freeQuota: number; // 今日剩余免费名额
  jobType: DOCTOR_JOBTYPE; // 1:全职|2:兼职
  fullTimeDoctorDesc: string; // 全职医生信息
  canBindPrescriber: boolean; // 医生是否有绑定开方医生的权限

  department: string; // 医生所属科室
  hospitalLevel: string; // 医生所属医院级别
  hospitalIndexId?: number; // 第三方医院医生id
  hospitalDoctorId?: string; // 医院索引id
  hospitalSecondDepartmentId?: string; // 医院科室id

  generalFee: number; // 急速问诊订单价格
  serviceTypeList: Array<{
    type: number;
    name: string;
    serviceFee: string;
    discount?: string;
  }>;
  serviceTypeMap: Record<
    number,
    {
      type: number;
      name: string;
      serviceFee: string;
      discount?: string;
    }
  >;
  originalPrice: number; // 原始价格
  priceDesc: string;
  minFee: number;
  asked: boolean;
  follow: boolean;
  currentStatus: number;
}

// 医生虚拟信息,IM 聊天时用
export interface IDoctorVirtualInfo {
  doctorVirtualId: number | string | undefined; // 医生接诊虚拟账号id，当前用户为医生时返回
  doctorVirtualSSecurity: string; // 医生接诊虚拟账号ssecurity，当前用户为医生时返回
  doctorVirtualST: string; // 医生接诊虚拟账号token，当前用户为医生时返回
}

export interface IRecommendDoctor {
  doctorDescription: string;
  doctorId: number;
  doctorName: string;
  doctorPhoto: string;
  // 是否是签约医生，是跳转频道主页，否跳转主站 profile
  healthConsulting: boolean;
}

export interface IRecommendDoctors {
  famousDoctors: IRecommendDoctor[];
  popularDoctors: IRecommendDoctor[];
}

export interface IDepartment {
  key: number;
  value: string;
}

export type IDepartments = IDepartment[];

export interface IDoctorTelReseve {
  currentDate: string;
  startTime: string;
  endTime: string;
  id: number;
  isAvailable: boolean;
}

export interface IDoctorTelReseveDay {
  date: string;
  isAvailable: boolean;
  reserveTimeList: Array<IDoctorTelReseve>;
  weekDay: string;
}

// 医生可预约挂号日期
export interface IDoctorSchedulingdate {
  id: string;
  sittingDate: string; // 日期:yyyy-MM-dd
  week: string; // 星期
  sittingTime: number; // 1上午|2下午
  type: string; // 号别
  clinicPrice: string; // 挂号费
  status: number; // 状态：0无号|1有号|2约满
}

// 赠送类型：1-赠送1次，2-赠送3次
export enum CONSULT_GIFT_TYPE {
  one = 1,
  three = 3
}

export interface IServiceTimeList {
  list: Array<{
    startTime: string;
    endTime: string;
  }>;
  week: string;
}

export interface IApplyService {
  affiliationHospital: string;
  avatar: string;
  doctorName: string;
  goodProject: string;
  hospitalLevelId: number;
  mobile: string;
  rankType: number;
  firstDepartmentId: string;
  secondDepartmentId: string;
  secondDepartmentName: string;
  serviceTypeList: IServiceTypeList[];
  serviceTimeList?: IServiceTimeList[];
  editStatus?: boolean;
  avatarId?: string;
}
export interface IResDepartmentBySecondDepartmentId {
  firstDepartmentId: number;
  firstDepartmentName: string;
  secondDepartmentName: string;
}

export enum SERVICE_STATUS {
  ONLINE = 1, // 审核通过正常服务
  OFFLINE = 2 // 服务下线，不支持下单
}

export interface IHealthChannelInfo {
  joinHealthChannel: boolean; // 用户是否加入健康频道服务
  enablePrivateMsg: boolean; // 医生是否开通私信服务
  affiliationHospital: string; // 出诊医院
  doctorId: number; // 对应快手id
  doctorName: string; // 医生名
  rankName: string; // 职级
  goodAt: string; // 擅长项目
  hospitalLevel: string; // 医院等级
  department: string; // 医生所属科室
  avatar: string; // 医生头像
  merchantId: number; // 医生虚拟id
  nickname: string; // 对应快手昵称
  serviceTypeList: Array<{
    // 医生开通相关咨询服务
    type: number;
    name: string;
    serviceFee: string;
    discount?: string;
  }>;
  status: ONLINE_STATUS; // 医生在线状态
  currentStatus: SERVICE_STATUS; // 医生的服务状态 为1时支持下单，为2时返回3012 服务下线不支持下单
}

// 医生的视频
export interface IShareWorksItem {
  caption: string;
  coverUrl: string;
  height: number;
  ksUrl: string;
  likeCount: number;
  photoId: string;
  innerPhotoId: string;
  poi: IPoi;
  timeMillis: number;
  userHeaderUrl: string;
  userId: number;
  userName: string;
  viewCount: number;
  width: number;
}

export interface IPoi {
  address: string;
  category: string;
  city: string;
  id: number;
  tittle: string;
}

export interface ILiveData {
  dates: string[];
  liveInfo: Record<string, ILiveInfo[]>;
}

export interface ILiveVideoVo {
  title: string; // 素材的标题
  userName: string; // 连麦对象/提问对象的昵称
  videoTimeDesc: string; // 时长描述
  coverUrl: string; // 封面图CDN地址
  materialLink: string; // 素材视频CDN地址
  materialSize: number; // 素材视频大小
}

export interface ILiveInfo {
  title: string; // 直播的标题
  liveStreamId: number; // 直播流ID
  videoVos: ILiveVideoVo[];
}
